export const testResultSelector = state => state.entities.testResults;
